import { render } from "./AbstractMenuBar.vue?vue&type=template&id=2badf9e9"
import script from "./AbstractMenuBar.vue?vue&type=script&lang=js"
export * from "./AbstractMenuBar.vue?vue&type=script&lang=js"

import "./AbstractMenuBar.vue?vue&type=style&index=0&id=2badf9e9&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__